import React from 'react';
import { Link } from 'react-router-dom';

/* Entrée du menu latéral ; le survol est géré en CSS (hover / group-hover). */
export function NavItem({ icon, label, active, onClick, collapsed, alert, to }) {
  const layout = collapsed
    ? 'gap-0 py-[14px] px-0 justify-center'
    : 'gap-[12px] py-[12px] px-[16px] justify-start';
  const state = active
    ? 'bg-mist text-navy font-bold'
    : 'bg-transparent text-slate font-medium hover:bg-ice hover:text-navy';
  return (
    <Link
      to={to || '#'}
      onClick={onClick}
      title={collapsed ? label : ''}
      className={`group relative flex items-center my-[1px] cursor-pointer text-[15px] no-underline [transition:background_0.12s,color_0.12s] ${layout} ${state}`}
    >
      <i
        className={`ti ${icon} text-[20px] shrink-0 [transition:color_0.12s] ${active ? 'text-accent' : 'text-taupe group-hover:text-accent'}`}
        aria-hidden="true"
      />
      {alert && (
        <span
          className={`absolute w-[8px] h-[8px] rounded-[50%] bg-danger [border:1.5px_solid_#fff] ${collapsed ? 'top-[8px] left-[32px] [transform:none]' : 'top-[50%] left-[20px] [transform:translateY(-9px)]'}`}
        />
      )}
      {!collapsed && label}
    </Link>
  );
}
